import { render, staticRenderFns } from "./Investors.vue?vue&type=template&id=09cf467e&"
import script from "./Investors.vue?vue&type=script&lang=js&"
export * from "./Investors.vue?vue&type=script&lang=js&"
import style0 from "./Investors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports